export const OFFSET_LIMIT = 8;

export const REVIEW_OFFSET_LIMIT = 3;

export const SEARCH_OFFSET_LIMIT = 16;

export const ALL_ACTIVITY_OFFSET_LIST: [number, number, number] = [8, 9, 4];

export const SEARCH_ACTIVITY_OFFSET_LIST: [number, number, number] = [16, 9, 8];